import { useEffect } from "react";
import { useState } from "react";
import CustomButton from "../Common/CustomButton/CustomButton";
import { Link } from "react-router-dom";
import { PRIVACY_POLICY } from "../../Constants/Route";
import { COOKIE_ALLOW } from "../../Constants/LocalStorage";


const AllowCookiesPopup = (props: any) => {

  const [cookieAccept, setCookieAccept] = useState(false);

  const onClickCookieAction = () => {
    localStorage.setItem(COOKIE_ALLOW, "allowed");
    setCookieAccept(true);
  }

  const onDeclineClickCookieAction = () => {
    localStorage.setItem(COOKIE_ALLOW, "notallowed");
    setCookieAccept(true);
  }

  useEffect(() => {
    const cookieStatus = localStorage.getItem(COOKIE_ALLOW);
    if (cookieStatus === "allowed" || cookieStatus === "notallowed") {
      setCookieAccept(true)
    }
    else {
      setCookieAccept(false)
    }
  }, [])

  return (
    cookieAccept ? null : 
    <div className="cookie-alert">
      <h6>Cookie Consent</h6>
      <p className="bl">We uses cookies to enhance your browsing experience. <Link className="bm" target={"_blank"} to={PRIVACY_POLICY}>Privacy Policy</Link></p>
      <div className="action-wrap">
        <CustomButton bg={"fill"} onClick={() => onClickCookieAction()}>
          Accept
        </CustomButton>
        <CustomButton onClick={() => onDeclineClickCookieAction()}>
          Decline
        </CustomButton>
      </div>
    </div>
  );
};

export default AllowCookiesPopup;
